import React, { useEffect, useState } from "react";
import ModalImage from "react-modal-image";
import useUniversalStore from "store/universalStore";
import dayjs from "dayjs";
import { transactionAPI, accountAPI } from "services";
import { ConfirmationModal, Loader } from "components";
import { formatMoney } from "utils";
import useOffcanvasStore from "store/offcanvasStore";

function Txn({ data, setLoader }) {
  const { transactionId, accountId, write, selectedMonth } = useUniversalStore((state) => state);
  const { openOffcanvas } = useOffcanvasStore();

  let attachment = data.get("attachment");
  const isPDF = attachment?.includes(".pdf");
  //TODO : If filename contains invalid characters, then change filename to valid filename
  const isImage = attachment?.match(/\.(jpg|jpeg|png|gif|webp)$/i);

  // useEffect(() => {
  //   console.log("data", data);
  // }, [data]);

  const handleModalOpen = () => {
    const modal = new window.bootstrap.Modal(document.getElementById('deleteTxnInKhataModal'));
    modal.show();
  };

  const deletetransaction = async () => {
    setLoader(true);
    try {
      await transactionAPI.deleteTransaction(transactionId);
      //Reset the transactionId
      write({
        transactionId: null,
        accounts: await accountAPI.getAccounts(),
        transactions: await transactionAPI.getTransactionsByAccountIdWithMonth(accountId, selectedMonth),
      });
    } catch (err) {
      console.error("deletetransaction error: ", err);
    } finally {
      setLoader(false);
    }
  };

  const editTransaction = () => {
    openOffcanvas("editTxn");
    write({ transactionId: data.id });
  }

  const cancelledView = () => {
    return (
      <>
        <div className="col-3 px-0" align="right">
          <i className="text-decoration-line-through text-muted">
            {formatMoney(data.get("amount"))}
          </i>
        </div>
        <div className="col-9">
          <div className="row">
            <div className="text-decoration-line-through text-muted col-8"
              align="left">
              {data.get("detail")}
            </div>
            <div className="text-decoration-line-through text-muted fst-italic col-4"
              align="right">
              {dayjs(data.get("date")).format("DD MMM")}
            </div>
          </div>
        </div>
      </>
    );
  };

  // const handleDownload = () => {
  //   const link = document.createElement('a');
  //   link.href = attachment;
  //   link.target = "_blank"
  //   link.download = 'filename.jpg'; 
  //   link.click();
  // };

  const normalView = () => {
    return (
      <div className="row">
        <div className="col-3 px-0" align="right">
          <i className="">
            {formatMoney(Math.abs(data.get("amount")))}
          </i>
        </div>
        <div className="col-8">
          <div className="row">
            <div className="col-8" align="left">
              {data.get("detail")}
            </div>
            <div className="col-4" align="right">
              <small><i>{dayjs(data.get("date")).format("DD MMM")}</i></small>
            </div>
          </div>
          {/* Attachments */}
          <div className="row">
            <div className="col-12">
              {isPDF && (
                <a className="text-decoration-none"
                  href={attachment}
                  target="_blank">
                  <i className="bi bi-file-pdf-fill text-app fs-1" />
                </a>
              )}

              {isImage && (
                <>
                  <ModalImage
                    small={attachment}
                    large={attachment}
                    hideDownload={true}
                    hideZoom={true}
                    alt={data.get("detail")}
                    className="mt-2 rounded-3"
                  />
                </>
              )}
            </div>
          </div>
        </div>
        {/* Dropdown to edit and delete the transaction */}
        <div className="col-1">
          {data.id ? (
            <a
              className="text-black btn bg-not-transparent-on-hover w-auto ms-auto"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="More options"
              align="right"
            >
              <span className="bi bi-three-dots-vertical"></span>
            </a>
          ) : null}
          <ul className="dropdown-menu row w-auto">
            <li className="col-12">
              <button className="w-100 btn btn-outline-app rounded"
                onClick={editTransaction}
              >
                <span className="bi bi-pencil-fill"> Edit</span>
              </button>
            </li>
            <li className="col-12 py-1">
              <button className="w-100 btn btn-app rounded fs-6"
                // data-bs-toggle="modal"
                onClick={() => {
                  write({ transactionId: data.id });
                  handleModalOpen()
                }}
                data-bs-target="#deleteTxnInKhataModal">
                <i className="bi bi-trash"> Delete</i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <li className="list-group-item bg-transparent">
      <div className="row align-items-baseline">
        {data.get("cancelled") ? cancelledView() : normalView()}
        <ConfirmationModal id="deleteTxnInKhataModal" onClick={deletetransaction} />
      </div>
    </li>
  );
}

export default Txn;
